module.exports = __webpack_public_path__ + "img/finance_BJ_SLT.dcb864ba.png";